import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import AnalyticsDropdownContent from 'views/Analytics/AnalyticsScrollMenu/AnalyticsDropdown/AnalyticsDropdownContent';
import styles from 'views/Analytics/AnalyticsScrollMenu/AnalyticsDropdown/AnalyticsDropdown.module.css';
import { DEFAULT_POPPER_CONFIG } from '../../../../constants/ui-constants';
import AnalyticsDropdownToggle from './AnalyticsDropdownToggle';

interface AnalyticsDropdownProps {
  /** Indicates where dropdown will be open */
  dropDownPlacement?: 'LEFT' | 'RIGHT';

  /** Offset of the menu used in relative positioning */
  leftOffset?: number;

  /** Disables click on open dropdown */
  disabled: boolean;
}

/**
 * Dropdown with selection of reports and running virtual service
 */
const AnalyticsDropdown = (props: AnalyticsDropdownProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
    }

    return () => {
      // Anything in here is fired on component unmount.
    };
  });

  const toggleDropdownToggleHandler = () => {
    if (props.disabled) {
      return;
    }

    //Toggle
    setIsOpen(!isOpen);
  };

  const onDropDownToggleKeyDown = (event: any) => {
    // When enabled and Enter Key is pressed
    if (!props.disabled && (event.keyCode === 13 || event.keyCode === 32)) {
      toggleDropdownToggleHandler();
    }
  };

  return (
    <Dropdown
      className={styles.dropdown}
      show={isOpen}
      style={{
        left: props.leftOffset ? props.leftOffset : 0 + 'px',
      }}
    >
      <Dropdown.Toggle
        id="add-new-metrics"
        as={AnalyticsDropdownToggle}
        onClick={toggleDropdownToggleHandler}
        onKeyDown={onDropDownToggleKeyDown}
      />
      <Dropdown.Menu
        popperConfig={DEFAULT_POPPER_CONFIG}
        role="menu"
        className={props.dropDownPlacement === 'RIGHT' ? 'dropdown-menu-right dropdown' : 'dropdown'}
        style={{ minWidth: '360px' }}
      >
        {/* Drop Down Content component */}
        <AnalyticsDropdownContent closeDropdownHandler={toggleDropdownToggleHandler} />
        {/* ./ Drop Down Content component */}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AnalyticsDropdown;
